
/**
 * Tells if val is of type "array".
 *
 * @param object	 	val
 *
 * @return bool
 */
export default function(val) {
	return Array.isArray(val);
};
